
/**
 * 处理报告页相关逻辑数据
 */
var REPORT_DATA_MANAGER = {
    /**
     * 根据服务器返回产品数据获取前端产品数据
     * @param {服务器返回数据} data 
     */
    getProductDataByData(data) {
        console.log('getProductDataByData------', data)
        var resultData = {}, resultList = [];
        for(var keys in data) {
            resultList.push(keys);
            resultData[keys] = {};
            resultData[keys].pid = data[keys].pid;
            resultData[keys].price = parseFloat(data[keys].price / 100);
            resultData[keys].rate_price = parseFloat(data[keys].rate_price / 100);
            resultData[keys].payType = data[keys].payType;
        }
        return {
            productList: resultList,
            productData: resultData
        }
    },
    /**
     * 根据服务器返回列表数据获取前端所需列表
     * @param {服务器返回列表} testList 
     */
    getReportListByTestList(testList) {
        testList.forEach(data => {
            console.log('getReportListByTestList------', data);
        });
    },

    /**
     * 根据服务器返回的新的测评报告数据来更新数据列表
     * @param {原来的数据列表} reportList 
     * @param {测评报告数据} reportData 
     */
    updateReportListAIDataByData(reportList, reportData) {
        var resultList = [];
        reportList.forEach(data => {
            if(data.id == reportData.id) {
                data['pay_10000'] = reportData.pay_10000;
                data['pay_10001'] = reportData.pay_10001;
                data['pay_10002'] = reportData.pay_10002;
                data['pay_10003'] = reportData.pay_10003;
                data['pay_10004'] = reportData.pay_10004;
                data['pay_10005'] = reportData.pay_10005;
                data.ai = Object.assign({}, reportData.ai);
            }
            resultList.push(data);
        });
        return resultList;
    },
    /**
     * 根据服务器返回的测评报告数据来获取前端所需数据
     * @param {测评报告数据} reportData 
     */
    getReportAIDataByData(reportData) {
        var resultData = {};
        for(var keys in reportData) {
            resultData[keys] = reportData[keys];
        }
        return resultData;
    }
}

export {
    REPORT_DATA_MANAGER
}